module.exports = __webpack_public_path__ + "static/img/strawberry-sunset-m.5c802d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/strawberry-sunset-m.jpg
// module id = Cnwy
// module chunks = 0